import React from "react";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";
import { Receipt } from "../modules/Order";

const Container = styled.div`
  flex: 80%;
  padding: 2rem;
`;

const ReceiptPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  if (params) {
    return (
      <Container>
        {params.get("ecodeUUID") !== "null" &&
          params.get("physicalUUID") !== "null" && (
            <b>
              To process your payment more quickly, your order has been split
              into two separate physical and ecode orders. Both receipts are
              shown below:
            </b>
          )}
        {params.get("ecodeUUID") !== "null" && (
          <Receipt orderId={params.get("ecodeUUID")} />
        )}
        {params.get("physicalUUID") !== "null" && (
          <Receipt orderId={params.get("physicalUUID")} />
        )}
      </Container>
    );
  }

  return null;
};

ReceiptPage.propTypes = {};

export default ReceiptPage;
